import useProductStore from '@/stores/productStore';

const ReviewUpgradeSales = () => {
  const productConfig = useProductStore(d => d.upgradeSales);

  return (
    <div className='flex flex-col'>
      {productConfig.some(data => data.feature === 'sales_recovery') && <span>Recuperação de vendas perdidas</span>}
      {productConfig.some(data => data.feature === 'multiple_cards') && <span>Múltiplos cartões</span>}
      {productConfig.some(data => data.feature === 'combined_payment') && <span>Combinar Cartão + Pix</span>}
      {productConfig.some(data => data.feature === 'installments_without_limitation') && (
        <span>Parcelamento sem limites</span>
      )}
      {productConfig.some(data => data.feature === 'installments_without_interest') && (
        <span>Parcelamento sem juros</span>
      )}
    </div>
  );
};

export default ReviewUpgradeSales;
